import Portal from '@components/Portal';
import Button from '@components/UI/Button';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';
import useMods from '@hooks/useMods';

import mailResponseAnimation from '@images/mailResponseAnimation.gif';

import Image from 'next/future/image';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const MailResponse = ({ mods, title, body  }) => {
    const { className } = useMods(MailResponse, { mods });
    const [isOpen, setIsOpen] = useState(true);

    const handlClick = () => setIsOpen(!isOpen);

    return (
        <>
            { isOpen && (
                <Portal>
                    <div
                        className={ className }
                    >
                        <Image
                            src={ mailResponseAnimation }
                            alt=''
                            height={ 245 }
                            width={ 250 }
                        />

                        <Heading
                            tag='h3'
                        >
                            <span
                                dangerouslySetInnerHTML={ { __html: title } }
                            />
                        </Heading>

                        <Paragraph
                            tag='p'
                        >
                            { body }
                        </Paragraph>

                        <Button
                            tag='button'
                            variant='secondary'
                            onClick={ handlClick }
                        >
                            OK
                        </Button>
                    </div>
                </Portal>
            ) }
        </>
    );
};

MailResponse.displayName = 'Mail-Response';

MailResponse.propTypes = {
    body: PropTypes.string,
    mods: PropTypes.object,
    title: PropTypes.string
};

MailResponse.defaultProps = {
    mods: {}
};

export default MailResponse;
